function Title({ title }) {
  return (
    <div className="">
      <h2
        className="text-[#006A4E] font-bold 
                text-4xl 
                md:text-5xl 
                lg:text-6xl 
                xl:text-6xl 
                2xl:text-7xl
                text-center md:text-left"
      >
        {title}
      </h2>
    </div>
  );
}

export default Title;